import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import 'moment/locale/cs';

import { SINGLE_OFFICE_MODE } from '../../config';
import RowHorizontal from '../../common/RowHorizontal/RowHorizontal';
import TitleTop from '../../common/TitleTop/TitleTop';
import InfoPanel from '../../common/InfoPanel/InfoPanel';

import { StyledReservationSuccess } from './styles/StyledReservationSuccess';

import { parseDateTimeToSpecificTimezone } from '../../common/Timezones';

class ReservationSuccess extends Component {
  render() {
    const {
      storeName,
      storeAddress,
      serviceName,
      reservedTime,
      emailConfirmation,
      pin,
    } = this.props.success;
    const { timezone } = this.props;
    const { previousSteps, } = this.props;
    const { officeData } = this.props;
    const time = parseDateTimeToSpecificTimezone(reservedTime, timezone).format();
    return (
      <StyledReservationSuccess>
        <InfoPanel
          locationData={{
            title: previousSteps.one,
            show: true,
            text1: storeName,
            text2: storeAddress,
            place: officeData.place,
            placeAdditionalInfo: officeData.place_additional_info,
            isLoading: false,
            status: true,
          }}
          serviceData={{
            title: previousSteps.two,
            show: true,
            text1: serviceName,
            isLoading: false,
            status: true,
          }}
          timeData={{
            title: previousSteps.three,
            show: true,
            text1: moment(time).format('D.MM.YYYY'),
            text2: moment(time).format('H:mm'),
            isLoading: false,
            status: true,
          }}
        />

        <RowHorizontal />

        <TitleTop
          number={SINGLE_OFFICE_MODE ? 3 : 4}
          title="Rezervace proběhla úspěšně"
        />

        {emailConfirmation &&
          <table className="reservation-success-table">
            <tbody>
              <tr>
                <td className="reservation-success-icon">
                  <i className="fa fa-envelope-open" aria-hidden="true"></i>
                </td>
                <td className="reservation-success-text">
                  <p role="status">Rezervaci je třeba potvrdit emailem.</p>
                </td>
              </tr>
            </tbody>
          </table>
        }

        {!emailConfirmation &&
          <table className="reservation-success-table">
            <tbody>
              <tr>
                <td className="reservation-success-icon">
                  <i className="fa fa-check" aria-hidden="true"></i>
                </td>
                <td className="reservation-success-text" role="status">
                  <p>Na email vám byly odeslány všechny potřebné informace.</p>
                  <p>PIN: {pin}</p>
                </td>
              </tr>
            </tbody>
          </table>
        }

      </StyledReservationSuccess>
    );
  }
}

ReservationSuccess.propTypes = {
  success: PropTypes.object.isRequired,
  timezone: PropTypes.string.isRequired,
};

export default ReservationSuccess;